// Footer.tsx
import React from "react";
// === ADDED BY SAMPATH – 2026-01-12 ===
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { useAppDispatch, useAppSelector } from "hooks/store";
import { toggleCart } from "store/slices/main.slice";
// === END SAMPATH ===

const Footer = () => {
  // === ADDED BY SAMPATH – 2026-01-12 ===
  // Keep cart count always updating (same store source as ToolBar).
  const dispatch = useAppDispatch();
  const cartLength = useAppSelector(({ main }) => main.cart.length);
  // === END SAMPATH ===

  // === ADDED BY SAMPATH – 2026-01-12 ===
  // Theme-driven button colors (primary) + hover colors (slightly darker bg)
  const btnBg = "rgb(var(--color-primary) / var(--tw-bg-opacity, 1))";
  const btnHoverBg = "rgb(var(--color-primary) / 0.85)"; // little bit darker / mixed

  // Default font color from theme (as requested)
  const defaultTextColor =
    "rgb(var(--color-themeSelColor) / var(--tw-text-opacity, 1))";
  // === END SAMPATH ===

  return (
    <>
      {/* === ADDED BY SAMPATH – 2026-01-12 === */}
      {/* Mobile “View Cart” footer like image (pill button + count badge) */}
      <div
        className="md:hidden fixed left-0 right-0 bottom-0 z-20 pb-3"
        // === ADDED BY SAMPATH – 2026-01-12 ===
        // Left & Right margin/padding set to 20px (was 10px)
        style={{ paddingLeft: "20px", paddingRight: "20px" }}
        // === END SAMPATH ===
      >
        <button
          type="button"
          onClick={() => dispatch(toggleCart())}
          className="
            w-full
            rounded-full
            flex items-center justify-between
            px-4 py-2.5
            shadow-[0px_10px_20px_#00000024]
            active:scale-[0.99]
            transition-colors duration-150
          "
          // === ADDED BY SAMPATH – 2026-01-12 ===
          // Reduce button width by limiting max-width + centering (keeps pill style)
          style={{
            backgroundColor: btnBg,
            color: defaultTextColor,
            maxWidth: "420px",
            marginLeft: "auto",
            marginRight: "auto",
          }}
          onMouseEnter={(e) => {
            (e.currentTarget as HTMLButtonElement).style.backgroundColor =
              btnHoverBg;
            (e.currentTarget as HTMLButtonElement).style.color =
              defaultTextColor;
          }}
          onMouseLeave={(e) => {
            (e.currentTarget as HTMLButtonElement).style.backgroundColor = btnBg;
            (e.currentTarget as HTMLButtonElement).style.color =
              defaultTextColor;
          }}
          // === END SAMPATH ===
        >
          <span className="flex items-center gap-2 font-semibold text-[14px]">
            {/* === ADDED BY SAMPATH – 2026-01-12 === */}
            {/* Reduce icon size a little bit */}
            <ShoppingCartIcon className="!text-[18px]" />
            {/* === END SAMPATH === */}
            View Cart
          </span>

          <span
            className="
              min-w-[26px] h-[26px]
              rounded-full
              flex items-center justify-center
              text-[12px] font-bold
              bg-white/25
              border border-white/30
            "
            // === ADDED BY SAMPATH – 2026-01-12 ===
            // Badge text uses DEFAULT theme font color.
            style={{ color: defaultTextColor }}
            // === END SAMPATH ===
          >
            {cartLength}
          </span>
        </button>
      </div>
      {/* === END SAMPATH === */}

      {/* Desktop footer (your original working footer kept) */}
      <footer
        className="text-themeSelColor bg-headerbgcolor text-center py-3 w-full fixed left-0 right-0 bottom-0 hidden md:block"
        // === ADDED BY SAMPATH – 2026-01-12 ===
        // Use DEFAULT theme font color (instead of forcing black)
        style={{
         // color: "rgb(var(--color-themeSelColor) / var(--tw-text-opacity, 1))",
         color: "black",
        }}
        // === END SAMPATH ===
      >
        &copy; Copyright 2014-2025 <b>Ranger Online</b>. All Rights Reserved
      </footer>
    </>
  );
};

export default Footer;
